import React, { useEffect } from 'react';
import AssessmentLayout from './AssessmentLayout';
import CardiovascularAssessmentForm from './CardiovascularAssessmentForm'

const CardiovascularAssessment = (props) => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, []);

  const redirectBack = () => {
    const { history, shiftReport } = props
    history.push(`/shift-report/clinical/v1/${shiftReport.id}/edit`);
  }

  const redirectToPulmonaryAssessment = () => {
    props.history.push(`/shift-report/clinical/v1/${props.shiftReport.id}/assessment/pulmonary`);
  }

  return (
    <AssessmentLayout {...props}>
      <h3 id="specific-assessment-header" className="block text-gray-600 text-3xl mb-6">Assessment - Cardiovascular</h3>
      <div className="bg-white justify-between rounded-lg shadow-md">
        <CardiovascularAssessmentForm
          onCancel={redirectBack}
          onContinue={redirectToPulmonaryAssessment}
          onSubmit={props.updateAssessment}
          assessment={props.assessment} />
      </div>
    </AssessmentLayout>
  );
}


export default CardiovascularAssessment;
